<div nz-row nzType="flex" [nzJustify]="'center'" style="margin-top: 65px;">
  <div nz-col nzSpan="7" nzOffset="5" style="bottom: -11px;">
    <app-stepper-base-button
      [actionText]="'Comparison'"
      [contentBlock]="true"
      [actionIcon]="faCalendarAlt"
      [height]="'110px'"
      [width]="'202px'"
      (onClick)="onClick('Comparison')"
    >
    </app-stepper-base-button>
    <div class="description-text">
      <span>
        Single period,
      </span>
      <span>
        multiple line items
      </span>
    </div>
  </div>
  <div nz-col nzSpan="10" nzOffset="2" style="bottom: -11px;">
    <app-stepper-base-button
      [actionText]="'Trend'"
      [contentBlock]="true"
      [actionIcon]="faCalendarWeek"
      [height]="'110px'"
      [width]="'202px'"
      (onClick)="onClick('Tend')"
    >
    </app-stepper-base-button>
    <div class="description-text">
      <span>
        Multiple periods,
      </span>
      <span>
        single line items
      </span>
    </div>
  </div>
</div>
